module.exports = __webpack_public_path__ + "img/ic_heart.527468b4.svg";